import React, { useState } from 'react';
import { Toolbar, Paper, Button, Grid, Typography, FormControlLabel, Checkbox } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import PlaylistAddOutlinedIcon from '@material-ui/icons/PlaylistAddOutlined';
import { Formik } from 'formik';

import SideMenu from '../../components/SideMenu';
import Alert from '../../components/Alert';
import Input from '../../components/Input';
import Select from '../../components/Select';
import Popup from '../../components/Popup';
import { ListPageHeading } from '../../components/ListPageLayout';

import api from '../../services/api';

export default function CustomInputCreate() {
    const classes = useStyles();

    const initialValues = {
        name: '',
        description: '',
        is_required: false,
        target: 'all',
        type: 'normal',
        options: [],
    };

    const [newOption, setNewOption] = useState('');
    const [openOptionsModal, setOpenOptionsModal] = useState(false);

    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };

    const resetForm = formik => {
        formik.resetForm();
    };

    const saveCustomInput = async (values, formik) => {
        try {

            const data = values;

            const result = await api.post('/custom_input/create', data);

            const { custom_input } = result.data;

            resetForm(formik);

            formik.setSubmitting(false);

            setMessage({
                open: true,
                variant: 'success',
                text: `Campo : ${custom_input.name} cadastrado com sucesso!`,
            });
        }
        catch (err) {
            console.log("ERROR: ", { err })
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    };

    const handleInsertNewOption = (word, insertedOptions, setFieldValue) => {
        const currentOptions = Object.assign([], insertedOptions);
        if (currentOptions.includes(word)) {
            setMessage({
                open: true,
                variant: 'error',
                text: "Essa opção ja existe",
            });
            return;
        }
        currentOptions.push(word);
        setFieldValue('options', currentOptions);
        setNewOption("")
    };

    const removeOption = (index, insertedOptions, setFieldValue) => {
        const currentOptions = Object.assign([], insertedOptions);
        currentOptions.splice(index, 1);
        setFieldValue('options', currentOptions);
    };

    const changeTarget = (value, setFieldValue) => {
        if (value === 'normal') {
            setFieldValue('options', []);
        }

        setFieldValue('type', value);
    }

    return (
        <div className={classes.root}>
            <SideMenu />
            <main className={classes.content}>
                <Toolbar />
                <Grid container spacing={3} className={classes.pageGrid}>
                    <Grid item xs={12}>
                        <ListPageHeading icon="customInput" title="Novo campo personalizado" />
                    </Grid>
                    <Formik
                        initialValues={initialValues}
                        onSubmit={saveCustomInput}
                    >
                        {({ values, handleChange, handleSubmit, isSubmitting, setFieldValue }) => (
                            <>
                                <Grid item xs={12}>
                                    <Paper elevation={0} className={classes.formCard}>
                                        <div className={classes.cardHeader}>
                                            <div className={classes.cardHeaderIcon}>
                                                <PlaylistAddOutlinedIcon />
                                            </div>
                                            <div>
                                                <Typography className={classes.cardTitle}>
                                                    Configuração do campo
                                                </Typography>
                                                <Typography className={classes.cardSubtitle}>
                                                    Crie uma informação adicional para complementar o cadastro de pessoas.
                                                </Typography>
                                            </div>
                                        </div>

                                        <form id="custom-input-create" onSubmit={handleSubmit} className={classes.form}>
                                            <div className={classes.formBody}>
                                                <div className={classes.infoBanner}>
                                                    <InfoOutlinedIcon />
                                                    <Typography>
                                                        Escolha onde o campo será exibido, seu formato e se o preenchimento será obrigatório.
                                                    </Typography>
                                                </div>

                                                <div className={classes.formSection}>
                                                    <div className={classes.sectionHeader}>
                                                        <Typography className={classes.sectionTitle}>
                                                            Informações básicas
                                                        </Typography>
                                                        <Typography className={classes.sectionDescription}>
                                                            Nome e descrição apresentados durante o cadastro.
                                                        </Typography>
                                                    </div>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} md={4}>
                                                            <Input
                                                                label="Nome"
                                                                textFieldProps={{
                                                                    name: 'name',
                                                                    id: 'name',
                                                                    placeholder: 'Nome do campo',
                                                                    onChange: handleChange,
                                                                    value: values.name,
                                                                    fullWidth: true,
                                                                    required: true,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={8}>
                                                            <Input
                                                                label="Descrição"
                                                                textFieldProps={{
                                                                    name: 'description',
                                                                    id: 'description',
                                                                    placeholder: 'Descrição do campo',
                                                                    onChange: handleChange,
                                                                    value: values.description,
                                                                    fullWidth: true,
                                                                    required: false
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </div>

                                                <div className={classes.formSection}>
                                                    <div className={classes.sectionHeader}>
                                                        <Typography className={classes.sectionTitle}>
                                                            Exibição e comportamento
                                                        </Typography>
                                                        <Typography className={classes.sectionDescription}>
                                                            Defina o perfil, o tipo de entrada dos dados e a obrigatoriedade.
                                                        </Typography>
                                                    </div>
                                                    <Grid container spacing={2} alignItems="stretch">
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Select
                                                                label='Formulário'
                                                                options={[
                                                                    { label: 'Regular e Visitante', value: 'all' },
                                                                    { label: 'Regular', value: 'regular' },
                                                                    { label: 'Visitante', value: 'guest' },
                                                                    { label: 'Procurado', value: 'wanted' }
                                                                ]}
                                                                textFieldProps={{
                                                                    name: 'target',
                                                                    id: 'target',
                                                                    required: true,
                                                                    fullWidth: true,
                                                                    value: values.target,
                                                                    onChange: handleChange,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Select
                                                                label='Tipo'
                                                                options={[
                                                                    { label: 'Texto', value: 'normal' },
                                                                    { label: 'Seleção', value: 'select' },
                                                                ]}
                                                                textFieldProps={{
                                                                    name: 'type',
                                                                    id: 'type',
                                                                    required: true,
                                                                    fullWidth: true,
                                                                    value: values.type,
                                                                    onChange: ({ target }) => changeTarget(target.value, setFieldValue),
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={4}>
                                                            <div className={`${classes.requiredCard}`}>
                                                                <FormControlLabel
                                                                    label={
                                                                        <div>
                                                                            <Typography className={classes.requiredTitle}>
                                                                                Campo obrigatório
                                                                            </Typography>
                                                                            <Typography className={classes.requiredText}>
                                                                                Exigir preenchimento no formulário
                                                                            </Typography>
                                                                        </div>
                                                                    }
                                                                    control={
                                                                        <Checkbox
                                                                            name='enabledToRequired'
                                                                            checked={values.is_required}
                                                                            onChange={() => setFieldValue('is_required', !values.is_required)}
                                                                            color="primary"
                                                                        />
                                                                    }
                                                                />
                                                            </div>
                                                        </Grid>
                                                    </Grid>

                                                    {values.type === "select" && (
                                                        <div className={classes.optionsSummary}>
                                                            <div>
                                                                <Typography className={classes.optionsSummaryTitle}>
                                                                    Opções de seleção
                                                                </Typography>
                                                                <Typography className={classes.optionsSummaryText}>
                                                                    {values.options.length === 0
                                                                        ? 'Nenhuma opção cadastrada'
                                                                        : `${values.options.length} ${values.options.length === 1 ? 'opção cadastrada' : 'opções cadastradas'}`}
                                                                </Typography>
                                                            </div>
                                                            <Button
                                                                onClick={() => setOpenOptionsModal(true)}
                                                                variant='outlined'
                                                                color='primary'
                                                                startIcon={<AddIcon />}
                                                                className={classes.manageOptionsButton}
                                                            >
                                                                Gerenciar opções
                                                            </Button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className={classes.formActions}>
                                                <Button
                                                    disabled={isSubmitting}
                                                    type="submit"
                                                    variant="contained"
                                                    form="custom-input-create"
                                                    color="primary"
                                                    endIcon={<SaveIcon />}
                                                    className={classes.saveButton}
                                                >
                                                    {isSubmitting ? 'Salvando...' : 'Salvar campo personalizado'}
                                                </Button>
                                            </div>
                                        </form>
                                    </Paper>
                                </Grid>
                                <Popup
                                    title='Opções do campo'
                                    openPopup={openOptionsModal}
                                    setOpenPopup={setOpenOptionsModal}
                                    width='92%'
                                    maxWidth='sm'
                                >
                                    <div className={classes.optionsModal}>
                                        <div className={classes.optionsModalIntro}>
                                            <div>
                                                <Typography className={classes.optionsModalTitle}>
                                                    Valores disponíveis
                                                </Typography>
                                                <Typography className={classes.optionsModalText}>
                                                    Adicione as respostas que poderão ser selecionadas neste campo.
                                                </Typography>
                                            </div>
                                            <span className={classes.optionsCount}>
                                                {values.options.length} itens
                                            </span>
                                        </div>
                                        <div className={classes.addOptionRow}>
                                            <div className={classes.newOptionField}>
                                                <Input
                                                    textFieldProps={{
                                                        placeholder: 'Nova opção',
                                                        onChange: ({ target }) => setNewOption(target.value),
                                                        value: newOption,
                                                        fullWidth: true,
                                                        required: true,
                                                    }}
                                                />
                                            </div>
                                            <Button
                                                onClick={() => handleInsertNewOption(newOption, values.options, setFieldValue)}
                                                variant='contained'
                                                color='primary'
                                                startIcon={<AddIcon />}
                                                className={classes.addOptionButton}
                                            >
                                                Adicionar
                                            </Button>
                                        </div>
                                        <div className={classes.keywordsContainer}>
                                            {
                                            values.options.map((currentOption, index) => {
                                                return (
                                                    <div key={index} className={classes.keyword}>
                                                        <Typography className={classes.keywordTitle}>{currentOption}</Typography>
                                                        <button
                                                            type="button"
                                                            aria-label={`Remover opção ${currentOption}`}
                                                            className={classes.keywordButton}
                                                            onClick={() => removeOption(index, values.options, setFieldValue)}
                                                        >
                                                            <CloseIcon />
                                                        </button>
                                                    </div>
                                                );
                                            })
                                        }
                                            {values.options.length === 0 && (
                                                <div className={classes.emptyOptions}>
                                                    As opções adicionadas aparecerão aqui.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Popup>
                            </>
                        )}
                    </Formik>
                </Grid>
                {!!message.open && (
                    <Alert
                        open={message.open}
                        autoHideDuration={6000}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        severity={message.variant}
                        onClose={closeMessage}
                    >
                        {message.text}
                    </Alert>
                )}
            </main>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        minHeight: '100vh',
    },
    content: {
        flexGrow: 1,
        minWidth: 0,
        padding: theme.spacing(3),
        marginBottom: theme.spacing(6),
        marginTop: theme.spacing(5),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    pageGrid: {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 1080,
    },
    formCard: {
        backgroundColor: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 16,
        boxShadow: '0 10px 30px rgba(15, 23, 42, .05)',
        overflow: 'hidden',
    },
    cardHeader: {
        alignItems: 'center',
        borderBottom: '1px solid #e5e7eb',
        display: 'flex',
        gap: theme.spacing(1.5),
        padding: theme.spacing(2.5, 3),
        [theme.breakpoints.down('xs')]: {
            alignItems: 'flex-start',
            padding: theme.spacing(2),
        },
    },
    cardHeaderIcon: {
        alignItems: 'center',
        backgroundColor: '#e3f2fd',
        borderRadius: 10,
        color: '#1976d2',
        display: 'flex',
        flexShrink: 0,
        height: 40,
        justifyContent: 'center',
        width: 40,
        '& svg': {
            fontSize: 21,
        },
    },
    cardTitle: {
        color: '#1e293b',
        fontSize: '1rem',
        fontWeight: 700,
    },
    cardSubtitle: {
        color: '#64748b',
        fontSize: '.82rem',
        lineHeight: 1.45,
        marginTop: 2,
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    formBody: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    infoBanner: {
        alignItems: 'flex-start',
        background: 'linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%)',
        border: '1px solid #dbeafe',
        borderRadius: 12,
        color: '#64748b',
        display: 'flex',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2.5),
        padding: theme.spacing(1.5),
        '& svg': {
            color: '#1976d2',
            flexShrink: 0,
            fontSize: 20,
            marginTop: 1,
        },
        '& p': {
            fontSize: '.82rem',
            lineHeight: 1.5,
        },
    },
    formSection: {
        backgroundColor: '#fbfdff',
        border: '1px solid #e2e8f0',
        borderRadius: 14,
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
    },
    sectionHeader: {
        marginBottom: theme.spacing(2),
    },
    sectionTitle: {
        color: '#1e293b',
        fontSize: '.95rem',
        fontWeight: 700,
    },
    sectionDescription: {
        color: '#64748b',
        fontSize: '.78rem',
        lineHeight: 1.4,
        marginTop: 1,
    },
    requiredCard: {
        alignItems: 'flex-end',
        display: 'flex',
        height: '100%',
        minHeight: 56,
        
    },
    requiredCardActive: {
        borderColor: '#90caf9',
        boxShadow: '0 4px 12px rgba(25, 118, 210, .07)',
    },
    requiredTitle: {
        color: '#475569',
        fontSize: '.84rem',
        fontWeight: 700,
    },
    requiredText: {
        color: '#94a3b8',
        fontSize: '.68rem',
        lineHeight: 1.3,
        marginTop: 1,
    },
    optionsSummary: {
        alignItems: 'center',
        backgroundColor: '#fff',
        border: '1px solid #dbeafe',
        borderRadius: 11,
        display: 'flex',
        gap: theme.spacing(2),
        justifyContent: 'space-between',
        marginTop: theme.spacing(2),
        padding: theme.spacing(1.5),
        [theme.breakpoints.down('xs')]: {
            alignItems: 'stretch',
            flexDirection: 'column',
        },
    },
    optionsSummaryTitle: {
        color: '#334155',
        fontSize: '.86rem',
        fontWeight: 700,
    },
    optionsSummaryText: {
        color: '#64748b',
        fontSize: '.72rem',
        marginTop: 2,
    },
    manageOptionsButton: {
        borderRadius: 9,
        flexShrink: 0,
        fontWeight: 600,
        textTransform: 'none',
    },
    formActions: {
        borderTop: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'flex-end',
        padding: theme.spacing(2, 3),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1.5, 2),
        },
    },
    saveButton: {
        borderRadius: 9,
        boxShadow: '0 6px 14px rgba(25, 118, 210, .2)',
        fontWeight: 700,
        minHeight: 42,
        minWidth: 230,
        textTransform: 'none',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    optionsModal: {
        paddingTop: theme.spacing(.5),
    },
    optionsModalIntro: {
        alignItems: 'center',
        background: 'linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%)',
        border: '1px solid #dbeafe',
        borderRadius: 12,
        display: 'flex',
        gap: theme.spacing(1.5),
        justifyContent: 'space-between',
        padding: theme.spacing(1.5),
    },
    optionsModalTitle: {
        color: '#172033',
        fontSize: '.9rem',
        fontWeight: 700,
    },
    optionsModalText: {
        color: '#64748b',
        fontSize: '.75rem',
        lineHeight: 1.4,
        marginTop: 2,
    },
    optionsCount: {
        backgroundColor: '#fff',
        border: '1px solid #bfdbfe',
        borderRadius: 999,
        color: '#1565c0',
        flexShrink: 0,
        fontSize: '.68rem',
        fontWeight: 700,
        padding: '4px 9px',
        whiteSpace: 'nowrap',
    },
    addOptionRow: {
        alignItems: 'stretch',
        display: 'flex',
        gap: theme.spacing(1),
        marginTop: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    newOptionField: {
        flex: 1,
        minWidth: 0,
        '& .MuiTextField-root': {
            width: '100%',
        },
    },
    addOptionButton: {
        borderRadius: 9,
        fontWeight: 600,
        minWidth: 130,
        textTransform: 'none',
    },
    keywordsContainer: {
        alignItems: 'flex-start',
        backgroundColor: '#fbfdff',
        border: '1px solid #e2e8f0',
        borderRadius: 12,
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        marginTop: theme.spacing(2),
        minHeight: 92,
        padding: theme.spacing(1.5),
    },
    keyword: {
        alignItems: 'center',
        backgroundColor: '#e3f2fd',
        border: '1px solid #bfdbfe',
        borderRadius: 999,
        display: 'flex',
        gap: theme.spacing(.5),
        minHeight: 32,
        padding: theme.spacing(.25, .5, .25, 1.25),
    },
    keywordTitle: {
        color: '#1565c0',
        fontSize: '.78rem',
        fontWeight: 700,
    },
    keywordButton: {
        background: 'transparent',
        border: 0,
        borderRadius: '50%',
        color: '#64748b',
        cursor: 'pointer',
        display: 'flex',
        padding: 3,
        '&:hover': {
            backgroundColor: '#fee2e2',
            color: '#b91c1c',
        },
        '& svg': {
            fontSize: 17,
        },
    },
    emptyOptions: {
        alignItems: 'center',
        color: '#94a3b8',
        display: 'flex',
        fontSize: '.78rem',
        justifyContent: 'center',
        minHeight: 60,
        textAlign: 'center',
        width: '100%',
    },
}));
